import dataBeleidHuisarts from "../../../../src/data/beleid-bloedingen-bij-de-huisarts.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBeleidHuisarts,
  BasicSchematic,
  React
};